import React, { useEffect, useState } from 'react';
import { Alert, Collapse, Empty, Spin, Typography } from 'antd';
import { faqService } from '../services/faq.service';
import { FaqItemPublic } from '../types/faq.types';

const { Title, Paragraph } = Typography;

export const FaqPage: React.FC = () => {
  const [items, setItems] = useState<FaqItemPublic[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    faqService
      .listPublic()
      .then(setItems)
      .catch((err: any) => {
        setError(err?.response?.data?.message || err?.message || 'Erro ao carregar perguntas frequentes');
      })
      .finally(() => setLoading(false));
  }, []);

  const collapseItems = items.map((item) => ({
    key: item.id,
    label: item.question,
    children: <Paragraph style={{ margin: 0, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{item.answer}</Paragraph>,
  }));

  return (
    <div style={{ width: '100%', maxWidth: 800, margin: '0 auto', padding: '40px 24px', boxSizing: 'border-box' }}>
      <Title level={2} style={{ marginBottom: 8 }}>
        Perguntas Frequentes
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 32 }}>
        Encontre respostas para as dúvidas mais comuns sobre o PePoll.
      </Paragraph>

      {loading && (
        <div style={{ textAlign: 'center', padding: '48px 0' }}>
          <Spin size="large" />
        </div>
      )}

      {!loading && error && (
        <Alert type="error" message={error} showIcon />
      )}

      {!loading && !error && items.length === 0 && (
        <Empty description="Nenhuma pergunta disponível no momento." />
      )}

      {!loading && !error && items.length > 0 && (
        <Collapse
          accordion={false}
          items={collapseItems}
          style={{ width: '100%', background: 'transparent' }}
        />
      )}
    </div>
  );
};

export default FaqPage;
